import axios from 'axios'

const $api = axios.create({
    baseURL: location.origin + '/api',
})

// 🎯 Добавляем токен авторизации во все запросы
$api.interceptors.request.use(config => {
    const accessToken = localStorage.getItem('accessToken')
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const locale = useCookie('Polyhen-language').value || 'he'

    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
    }
    if (csrfToken) {
        config.headers['X-CSRF-TOKEN'] = csrfToken
    }
    config.headers['Accept-Language'] = locale

    return config
}, error => Promise.reject(error))

$api.interceptors.response.use(
    response => response, // если всё хорошо — просто вернуть
    error => {
        if (error.response?.status === 401) {
            // Очищаем localStorage при 401 ошибке
            localStorage.removeItem('accessToken')
            localStorage.removeItem('userData')
            localStorage.removeItem('userAbilityRules')
            window.location.href = '/login'
        }

        return Promise.reject(error)
    }
)

export default $api
